import "material-design-icons-iconfont/dist/material-design-icons.css"; // Ensure you are using css-loader
import Vue from "vue";
import Vuetify from "vuetify/lib";
import colors from 'vuetify/lib/util/colors'
import VuetifyConfirm from "vuetify-confirm";
import fr from "vuetify/src/locale/fr.ts";
Vue.use(Vuetify);
const options = {
  
  lang: {
    locales: { fr },
    current: "fr",
  },

  icons: {
    iconfont: "mdi" || "mdiSvg" || "md",
  },
  theme: {
    //dark: true,
    themes: {
      light: {
        primary: "#24CCA7",
        secondary: "#2E7D32",
        accent: "#1E88E5",
        error: "#b71c1c",
        anchor: "#1E88E5",
        background: "#333D42",
        warning: "#FF9800",
        danger: "#B71C1C",
        success: "#43A047",
        info: "#5A35B5",
        'light-green-lighten-3':"#C5E1A5"
      },
      dark: {
        primary: "#2857EE",
        background: "#333D42",
      },
    },
  },
};
const vuetify = new Vuetify(options);
Vue.use(VuetifyConfirm, {
  vuetify,
  buttonTrueText: "Continuer",
  buttonFalseText: "Annuler",
  color: "error",
  icon: "warning",
  title: "Attention",
  width: 350,
  property: "$confirm",
});

export default vuetify;
